<div id="page-header-loader" class="overlay-header bg-primary" [ngClass]="{show: show === true}">
  <div class="content-header content-header-fullrow text-center">
    <div class="content-header-item">
      <i class="fa fa-sun-o fa-spin text-white"></i>
    </div>
  </div>
</div>
